import React, { useState } from "react";
import "./styles.scss"

function ConfirmationPopup({ selectedRoom, closePopup, showReservationForm }) {


    const [adminPass, setAdminPassword] = useState("")
    const [errorText, setErrorText] = useState("")

    function modifyInformation() {
        if (adminPass == process.env.REACT_APP_ADMIN_PASSWORD) {
            showReservationForm(selectedRoom);
            closePopup()
        }
        else{
            setErrorText("Please Enter Correct Admin Password")
            setTimeout(() => {
                setErrorText("") 
            }, 3000);
        }
    }

    return (
        <div className="confirmation-popup-root">
            <p>Are you sure you want to modify <b>Room No {selectedRoom}</b>?</p>
            <input className="confirmation-input" placeholder="Please Enter Admin Password.." onChange={(e)=>setAdminPassword(e.target.value)} value={adminPass} required/>
            <span className="error-text">{errorText}</span>
            <div className="confirmation-buttons">
                <div className="confirm" onClick={modifyInformation}>Modify Reservation</div>
                <div className="cancel" onClick={closePopup}>Cancel Reservation</div>
            </div>
        </div>
    )
}

export default ConfirmationPopup